import React from "react"
import PropTypes from "prop-types"
import useProfileStore from "../profileStore"

export default function AccountInfo({
  editPasswordButtonId,
  headingAccountInformation,
  labelMembershipNumber,
  labelPassword,
  editPasswordLinkLabel,
}) {
  const { membershipNumber, setIsPasswordModalOpen } = useProfileStore()

  return (
    <div className="form--profile__account-info">
      <div className="form__section form__section--no-border clearfix">
        <h3 className="profile-section-header">{headingAccountInformation}</h3>
        <div className="form__section__inner">
          <div className="grid">
            <div className="grid-item col--12 col-sm--6">
              <h4 className="profile-section-subheader">{labelMembershipNumber}</h4>
              <p>{membershipNumber}</p>
            </div>
            <div className="grid-item col--12 col-sm--3">
              <h4 className="profile-section-subheader">{labelPassword}</h4>
              <p aria-hidden="true">********</p>
            </div>
            <div className="grid-item col--12 col-sm--3">
              <button id={editPasswordButtonId} type="button" className="button--link link" onClick={(e) => setIsPasswordModalOpen(e)}>
                <span className="link edit-password-link">{editPasswordLinkLabel}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

AccountInfo.propTypes = {
  headingAccountInformation: PropTypes.string.isRequired,
  labelMembershipNumber: PropTypes.string.isRequired,

  labelPassword: PropTypes.string.isRequired,
  editPasswordLinkLabel: PropTypes.string.isRequired,
}
